<template>
  <div class="manager-deadline-root">
    <div v-if="!deadline" class="text-gray-500">–</div>
    <OurTag v-else-if="isOverdue" size="md" color="red" :text="overdueLabel" />
    <div v-else class="manager-deadline tabular-nums">
      {{ formattedTime }}
    </div>
  </div>
</template>

<script>
export default {
  name: "ManagerDeadlineTimer",

  props: {
    deadline: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      displaySeconds: 0,
      tickerId: null,
    };
  },

  computed: {
    isOverdue() {
      if (!this.deadline) {
        return false;
      }

      return Boolean(this.deadline.isOverdue) || this.displaySeconds <= 0;
    },

    formattedTime() {
      return this.formatRemaining(this.displaySeconds);
    },

    shouldTick() {
      return Boolean(this.deadline?.isRunning) && !this.isOverdue;
    },

    overdueLabel() {
      return `! ${this.$t("label.overdue")}`;
    },
  },

  watch: {
    deadline: {
      handler: "syncFromDeadline",
      immediate: true,
      deep: true,
    },

    shouldTick(isTicking) {
      if (isTicking) {
        this.startTicker();
      } else {
        this.stopTicker();
      }
    },
  },

  mounted() {
    if (this.shouldTick) {
      this.startTicker();
    }
  },

  beforeDestroy() {
    this.stopTicker();
  },

  methods: {
    syncFromDeadline(deadline) {
      if (!deadline) {
        this.displaySeconds = 0;

        return;
      }

      const seconds = Number(deadline.remainingSeconds);

      this.displaySeconds = Number.isFinite(seconds) ? seconds : 0;
    },

    formatRemaining(totalSeconds) {
      const total = Math.max(0, Math.floor(totalSeconds));
      const hours = Math.floor(total / 3600);
      const minutes = Math.floor((total % 3600) / 60);

      return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
    },

    startTicker() {
      if (this.tickerId) {
        return;
      }

      this.tickerId = setInterval(() => {
        if (this.deadline?.isRunning && this.displaySeconds > 0) {
          this.displaySeconds -= 1;
        }
      }, 1000);
    },

    stopTicker() {
      if (!this.tickerId) {
        return;
      }

      clearInterval(this.tickerId);
      this.tickerId = null;
    },
  },
};
</script>
